export default __webpack_public_path__ + "static/media/7-small.2710f399.png";